<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户绑定设备列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>用户绑定设备列表</span>
        </div>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border size="mini" :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="nickname" label="昵称" width="160"></el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="company" label="绑定车型"></el-table-column>
          <el-table-column prop="devid" label="设备ID" width="100"></el-table-column>
          <el-table-column prop="dev_id" label="模组ID" width="120"></el-table-column>
          <el-table-column prop="dev_type" label="设备类型" width="90"></el-table-column>
          <el-table-column prop="is_online" label="联网状态" width="90">
            <template slot-scope="scope">
              <el-link v-if="scope.row.is_online == 1" type="success" :underline="false">在线</el-link>
              <el-link v-else type="danger" :underline="false">离线</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_time" label="在线总时长" width="140"></el-table-column>
          <el-table-column prop="atime" label="用户激活日期" width="120"></el-table-column>
          <el-table-column prop="etime" label="VIP到期日" width="120"></el-table-column>
          <el-table-column prop="unbind_time" label="解/绑日期" width="120"></el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        type: "",
        keys: "",
      },
      category: [],
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/dev/destroy_bind", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        });
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.search.type = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.type = that.search.type;
      that.axios.post("/dev/devbind", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>